import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PendingApprovals from "./PendingApprovals";
import CheckerMyRequests from "./CheckerMyRequests";

function DealerMapCheckerTabs(props) {
const location = useLocation();
// The request details page hands back the tab it wants opened (Dashboard /
// Pending Approvals), otherwise the dashboard is the landing tab.
const [activeTab, setActiveTab] = useState(location.state?.activeTab || "dashboard");

    return (
        <div className="dealer-mapping-main">
            <Header title={props.title} portal={""} showUserId />
            <SingleSignOnSideBar />
            <main id="dealermap-main-content">
                <div className="tab-content card-box cl-mapping-tab" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    > 
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "dashboard" ? "active" : ""}`}
                                            id="dashboard-tab"
                                            data-toggle="tab"
                                            data-target="#dashboard"
                                            type="button"
                                            role="tab"
                                            aria-controls="dashboard"
                                            aria-selected="true"
                                            onClick={() => setActiveTab("dashboard")}
                                        >
                                            Dashboard
                                        </button>
                                    </li>
                                    {/* <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "pendingApp" ? "active" : ""}`}
                                            id="pendingApp-tab"
                                            data-toggle="tab"
                                            data-target="#pendingApp"
                                            type="button"
                                            role="tab"
                                            aria-controls="pendingApp"
                                            aria-selected="false"
                                            onClick={() => setActiveTab("pendingApp")}
                                        >
                                            Pending Approvals
                                        </button>
                                    </li> */}
                                </ul>
                            </div>

                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >

                                        {activeTab === "dashboard" && (
                                            <CheckerMyRequests setActiveTab={setActiveTab} />
                                        )}
                                        {activeTab === "pendingApp" && (
                                            <PendingApprovals setActiveTab={setActiveTab} />
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default DealerMapCheckerTabs;
